import { sortableHandle } from 'react-sortable-hoc';
import { components } from 'react-select';
import React from 'react';

export default sortableHandle(props => (
  <components.MultiValueLabel className="sort-multi-value-label" {...props} />
));
